export default {
  apps: "/apps",
  settings: {
    plan: "/plan",
    invoice: "/invoice",
    security: "/security",
    payment: "/payment"
  }
};
